import { ORCHESTRATION_WS_METHODS } from "@t3tools/contracts";
import { Atom } from "effect/unstable/reactivity";

import { createEnvironmentRpcCommand, createEnvironmentRpcQueryAtomFamily } from "./runtime.ts";
import type { EnvironmentRegistry } from "../connection/registry.ts";

export function createOrchestrationEnvironmentAtoms<R, E>(
  runtime: Atom.AtomRuntime<EnvironmentRegistry | R, E>,
) {
  return {
    archivedShellSnapshot: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:orchestration:archived-shell-snapshot",
      tag: ORCHESTRATION_WS_METHODS.getArchivedShellSnapshot,
    }),
    turnDiff: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:orchestration:turn-diff",
      tag: ORCHESTRATION_WS_METHODS.getTurnDiff,
    }),
    fullThreadDiff: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:orchestration:full-thread-diff",
      tag: ORCHESTRATION_WS_METHODS.getFullThreadDiff,
    }),
    importableProviderProjects: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:orchestration:importable-provider-projects",
      tag: ORCHESTRATION_WS_METHODS.listImportableProviderProjects,
      staleTimeMs: 5_000,
      idleTtlMs: 30_000,
    }),
    importableProviderSessions: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:orchestration:importable-provider-sessions",
      tag: ORCHESTRATION_WS_METHODS.listImportableProviderSessions,
      staleTimeMs: 5_000,
      idleTtlMs: 30_000,
    }),
    importProviderSession: createEnvironmentRpcCommand(runtime, {
      label: "environment-command:orchestration:import-provider-session",
      tag: ORCHESTRATION_WS_METHODS.importProviderSession,
      concurrency: {
        mode: "singleFlight",
        key: ({ environmentId, input }) =>
          `${environmentId}:${input.projectId}:${input.providerInstanceId}:${input.candidateRef}`,
      },
    }),
  };
}
